module.exports = __webpack_public_path__ + "static/media/How to send SMS.58490b18.png";